<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'ApplicationCenter', to: { path: '/application-detail' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>ApplicationCenter</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toApplicationCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增Application</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <ApplicationCenterTable></ApplicationCenterTable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ApplicationCenterTable from '@/views/B-13__ApplicationDetail/c/ApplicationCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    ApplicationCenterTable,
  },
  created() {
    this.clear();
    this.getApplicationList();
  },
  methods: {
    ...mapActions('application', {
      getApplicationList: 'find',
      clear: 'clear',
    }),
    toApplicationCreate() {
      this.$router.push('/application-detail/create');
    },
  },
};
</script>

<style></style>
